import React from 'react';
import styled from '@emotion/styled';


// ============================================
// STYLED COMPONENTS
// ============================================

const Section = styled.section`
    padding: 60px 0;
    background: #fdfdfd;
    border-bottom: 1px dashed #e5e7eb;
    position: relative;
`;

const Container = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
`;

const SectionHeader = styled.p`
    text-align: center;
    font-family: 'Inter', sans-serif;
    font-size: 0.9rem;
    color: #6b7280;
    margin-bottom: 40px;
    font-weight: 500;
`;

// Grid Layout
const LogoGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(6, 1fr); /* Single row for all 6 clients */
    border-top: 1px solid #e5e7eb;
    border-left: 1px solid #e5e7eb;

    @media (max-width: 1024px) {
        grid-template-columns: repeat(3, 1fr); /* 2 rows on tablet */
    }
    
    @media (max-width: 640px) {
        grid-template-columns: repeat(2, 1fr); /* 3 rows on mobile */
    }
`;

const ClientItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 24px;
    height: 120px;
    border-right: 1px solid #e5e7eb;
    border-bottom: 1px solid #e5e7eb;
    background: transparent;
    transition: all 0.2s ease;
    
    /* Hover Effect: Subtle lift & glow */
    &:hover {
        background: #ffffff;
        box-shadow: 0 4px 20px rgba(0,0,0,0.03);
        z-index: 1;
        position: relative;
        
        img {
            filter: grayscale(0%);
            opacity: 1;
            transform: scale(1.05);
        }
    }
`;

const ClientIcon = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    
    img {
        max-width: 100%;
        max-height: 50px;
        width: auto;
        object-fit: contain;
        filter: grayscale(100%);
        opacity: 0.6;
        transition: all 0.3s ease;
    }
`;

// ============================================
// DATA
// ============================================

const clients = [
    { name: 'The TEFL Institute', logo: '/Clients/The_TEFL_Institute_full.svg' },
    { name: 'TEFL Institute of Ireland', logo: '/Clients/TEFL_Ireland_full.svg' },
    { name: 'Premier TEFL', logo: '/Clients/premier_tefl_full.svg' },
    { name: 'Hair Repair Clinic UK', logo: '/Clients/hair_repair_clinic_full.webp' },
    { name: 'Surgery Group UK', logo: '/Clients/surgery_group_full.png' },
    { name: 'Government Employees Pension Fund', logo: '/Clients/gepf_full.png' },
];

// ============================================
// COMPONENT
// ============================================

const ClientTrustSection: React.FC = () => {
    return (
        <Section>
            <Container>
                <SectionHeader>
                    Trusted by forward-thinking teams
                </SectionHeader>

                <LogoGrid>
                    {clients.map((client, index) => (
                        <ClientItem key={index}>
                            <ClientIcon>
                                <img
                                    src={client.logo}
                                    alt={`${client.name} logo`}
                                />
                            </ClientIcon>
                        </ClientItem>
                    ))}
                </LogoGrid>
            </Container>
        </Section>
    );
};

export default ClientTrustSection;
